import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { TeamsFavoritesService } from '../../../../services/teams-favorites.service';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NzSkeletonComponent } from 'ng-zorro-antd/skeleton';
import { NoResultComponent } from '../../../../components/shared/no-result/no-result.component';
import { NzGridModule } from 'ng-zorro-antd/grid';

@Component({
  selector: 'app-lineup',
  standalone: true,
  imports: [CommonModule, TranslateModule, NzSkeletonComponent, NoResultComponent, NzGridModule],
  templateUrl: './lineup.component.html',
  styleUrl: './lineup.component.scss'
})
export class LineupComponent {
  @Input() idTeam: any;

  lineUp: any;
  loading = true;

  urlSVG = environment.urlIcon;

  constructor(
    private ref: ChangeDetectorRef,
    private teamService: TeamsFavoritesService
  ) {}

  ngOnInit(): void {
    this.loadLineUp(this.idTeam);
  }

  loadLineUp(id: any) {
    this.teamService.getTeamLineUpById(id).subscribe(
      (result: any) => {
        if (result.status) {
          this.lineUp = result.lineUp;
          this.loading = false;
        } else {
          this.lineUp = null;
          this.loading = false;
        }
      },
      () => {
        this.loading = false;
      }
    );
  }
}
